function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "bxs-book-content",
  d: "M100.754,4.5H13.862A10.87,10.87,0,0,0,3,15.362V91.392a10.87,10.87,0,0,0,10.862,10.862h86.892a10.87,10.87,0,0,0,10.862-10.862V15.362A10.87,10.87,0,0,0,100.754,4.5ZM95.323,26.223V37.085H68.169V26.223ZM68.169,47.946H95.323V58.808H68.169ZM13.862,91.392V15.362H51.877V91.392Z",
  transform: "translate(-3 -4.5)",
  fill: "#ac1ede"
});

var SvgBxsBookContent = function SvgBxsBookContent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108.615,
    height: 97.754,
    viewBox: "0 0 108.615 97.754",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBxsBookContent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bxs-book-content.6ebe8b37.svg";
export { ForwardRef as ReactComponent };